export default __webpack_public_path__ + "static/media/No_Image.631a495a.png";